/** 各調査項目の危険度ランク */
export const RISK_RANK = {
  /** 未選択 */
  UNSELECTED: '-1',
  /** Aランク */
  RANK_A: '1',
  /** Bランク */
  RANK_B: '2',
  /** Cランク */
  RANK_C: '3'
} as const
